module.exports = __webpack_public_path__ + "img/aside-mid.24ba388a.png";